var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 70,
    viewBox: "0 0 53 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3292 38.4506C2.27153 36.4817 2.27153 33.1942 4.3292 31.2253L23.6279 12.7593C26.8081 9.71627 32.0846 11.9703 32.0846 16.3719V53.304C32.0846 57.7056 26.8081 59.9596 23.6279 56.9166L4.3292 38.4506Z",
    fill: "#7A878A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.1631,
    y: 22.0542,
    width: 25.2088,
    height: 25.9459,
    rx: 5,
    fill: "#7A878A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackDark);
export default __webpack_public_path__ + "static/media/back_dark.01d811c2a4252d5b86d5299b586c1f46.svg";
export { ForwardRef as ReactComponent };